import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-images';

import { useDocumentPreview } from '../../../../hooks/useDocumentPreview';

const UserDocumentsPreview = ({ documents }) => {
  const {
    activeImageIdx,
    images,
    nextImage,
    prevImage,
    resetImageIdx,
  } = useDocumentPreview(documents);

  return (
    <Lightbox
      images={images}
      isOpen={activeImageIdx !== null}
      onClickPrev={prevImage}
      onClickNext={nextImage}
      onClose={resetImageIdx}
      currentImage={activeImageIdx}
      backdropClosesModal
      showImageCount={false}
      preloadNextImage={false}
    />
  );
};

UserDocumentsPreview.propTypes = {
  documents: PropTypes.array.isRequired,
};

export default UserDocumentsPreview;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/InsuranceDetails/UserDocumentsPreview/index.jsx